import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { BodyS, Caption, HeadingLBold, BodySBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import Badge from 'components/Badge/Badge';
import CanPerform from 'components/CanPerform/CanPerform';
import CustomButton from 'components/CustomButtons/Button';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/detailsStyle';
import { makeStyles } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import UserIcon from 'components/UserIcon/UserIcon';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IUserDetailsHeaderProps {
	user: types.users.IExtendedCorpUserDetails;
	canPerformAction: string;
	openEditUserDialog: () => void;
}

const UserDetailsHeader = ({ user, canPerformAction, openEditUserDialog }: IUserDetailsHeaderProps) => {
	const classes = useStyles();

	return (
		<GridContainer>
			<GridItem xs={12} lg={2}>
				<Card className={classes.iconCard}>
					<CardBody className={classes.iconCardBody}>
						<UserIcon type={user.userData.userType} />
					</CardBody>
				</Card>
			</GridItem>
			<GridItem xs={12} lg={10}>
				<Card>
					<CardBody>
						<Caption color="secondary-light">{translate('user.name')}</Caption>
						<div>
							<HeadingLBold inline>{user.userData.userName}</HeadingLBold>
							<Badge filled hexColor={user.userData.departmentUiColor} className={classes.badge}>
								{user.userData.departmentName}
							</Badge>
						</div>
						<div className={classes.email}>
							<BodySBold color="secondary-light" disableMargin inline>
								{translate('user.information.email')}
							</BodySBold>
							<BodyS color="secondary-light" disableMargin inline>
								{user.userData.email}
							</BodyS>
						</div>
						<ConditionalRender
							show={!!user.userData.contactNumber1}
							onTrue={() => (
								<div className={classes.contactNumber}>
									<BodySBold color="secondary-light" disableMargin inline>
										{translate('user.information.contact.number')}
									</BodySBold>
									<BodyS color="secondary-light" disableMargin inline>
										{user.userData.contactNumber1}
									</BodyS>
								</div>
							)}
						/>
						<CanPerform
							action={canPerformAction}
							yes={
								<CustomButton
									color="tertiary-light"
									onClick={openEditUserDialog}
									className={classes.editButton}
									id="edit-user-info-button"
								>
									{translate('edit')}
								</CustomButton>
							}
						/>
					</CardBody>
				</Card>
			</GridItem>
		</GridContainer>
	);
};

export default UserDetailsHeader;
